<template>
  <div v-if="editor">
    <v-row
      no-gutters
      style="position: relative"
      @click="openFieldOptions"
      v-click-outside="closeFieldOptions"
    >
      <v-col cols="12" class="tiptapClass">
        <editor-content :editor="editor" />
      </v-col>
      <v-card
        v-if="fieldOptions"
        class="mt-16 floating-card"
        style="user-select: none"
        elevation="4"
        width="700px"
      >
        <v-row no-gutters>
          <v-col
            cols="12"
            class="d-flex justify-space-between align-center py-1 pl-3"
          >
            <span>Insira os dados:</span>
            <v-btn icon @click="closeFieldOptions" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-divider />
          </v-col>
          <v-col cols="12" class="pl-3 py-2">
            <v-row no-gutters>
              <v-col
                cols="12"
                class="mt-2"
                v-for="(webhookField, i) in fieldTitles"
                :key="i"
              >
                <v-chip @click="addTiptapMention(webhookField)">
                  {{ webhookField }}
                </v-chip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
  </div>
</template>

<script>
import Mention from '@tiptap/extension-mention'
import { Editor, EditorContent } from '@tiptap/vue-2'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'

export default {
  components: {
    EditorContent,
  },
  props: {
    name: String,
    webhookFields: Array,
    contentValue: Array,
  },
  data() {
    return {
      editor: null,
      fieldOptions: false,
      webhookOptions: [],
    }
  },
  computed: {
    fieldTitles() {
      return this.webhookFields.map((field) => field.title)
    },
  },
  watch: {
    contentValue: {
      immediate: true,
      deep: true,
      handler(val) {
        if (this.editor) {
          if (val.length) {
            this.setInputContent(val)
          } else {
            this.editor.commands.clearContent()
          }
        }
      },
    },
  },
  created() {},
  mounted() {
    this.editor = new Editor({
      extensions: [
        Document,
        Paragraph,
        Text,
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
        }),
      ],
      content: '',
    })
    this.$root.$on(`getValue-${this.name}`, () => {
      this.$root.$emit('updateFieldValue', this.name, this.editor.getJSON())
    })
    this.setInputContent(this.contentValue)
  },
  beforeDestroy() {
    this.$root.$off(`getValue-${this.name}`)
    this.$root.$off(`setContent-${this.name}`)
  },
  methods: {
    setInputContent(content) {
      this.editor.commands.setContent({
        type: 'doc',
        content: [
          {
            type: 'paragraph',
            content: content,
          },
        ],
      })
    },
    addTiptapMention(val) {
      this.editor.commands.insertContent({
        type: 'mention',
        attrs: {
          id: `${val}`,
          label: null,
        },
      })
    },
    openFieldOptions() {
      this.fieldOptions = true
    },
    closeFieldOptions() {
      if (this.fieldOptions) {
        setTimeout(() => {
          this.fieldOptions = false
        }, 50)
      }
    },
  },

  beforeUnmount() {
    this.editor.destroy()
  },
}
</script>

<style lang="scss">
.tiptapClass {
  padding: 15px 5px 5px 10px !important;
  border: 1px solid rgb(158 158 158);
  border-radius: 5px;
}

.floating-card {
  position: absolute !important;
  z-index: 999 !important;
}

.ProseMirror {
  > * + * {
    margin-top: 0.75em;
  }
}

.ProseMirror:focus {
  outline: none;
}

#someselector {
  all: initial;
  * {
    all: unset;
  }
}

.mention {
  border: 1px solid #000;
  border-radius: 0.4rem;
  padding: 0.1rem 0.3rem;
  box-decoration-break: clone;
}
</style>
